/**
 * Round reporter avatar. Reporters are transient magic-link identities with no
 * uploaded photo, so we render a striking initials-on-gradient badge instead of
 * a dull placeholder. The gradient is derived deterministically from the email
 * so the same person always gets the same colours.
 */
const GRADIENTS: [string, string][] = [
  // No purple: the admin palette dropped it, and an avatar is still admin
  // chrome. Hues stay far apart so two people never read as the same person.
  ['#0F766E', '#06B6D4'],
  ['#2563EB', '#06B6D4'],
  ['#B45309', '#EF4444'],
  ['#10B981', '#84CC16'],
  ['#1D4ED8', '#3B82F6'],
  ['#BE185D', '#F59E0B'],
  ['#06B6D4', '#22C55E'],
  ['#F43F5E', '#B45309'],
];

function hash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

function initials(name: string, email: string): string {
  const src = (name || email || '?').trim();
  const parts = src.split(/[\s@._-]+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

export function ReporterAvatar({
  name,
  email,
  size = 40,
}: {
  name: string;
  email: string;
  size?: number;
}) {
  const [from, to] = GRADIENTS[hash(email || name) % GRADIENTS.length];
  return (
    <span
      className="flex items-center justify-center rounded-full font-black text-white shadow-sm ring-2 ring-[var(--color-bg-surface)]"
      style={{
        width: size,
        height: size,
        fontSize: size * 0.4,
        background: `linear-gradient(135deg, ${from}, ${to})`,
        fontFamily: 'var(--font-display)',
      }}
      aria-hidden="true"
    >
      {initials(name, email)}
    </span>
  );
}
